export default __webpack_public_path__ + "static/media/Darkblade's Bracers of Supreme Decree.4732fa4e.jpg";